
import React, { useEffect, useRef, useState } from "react";
// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
  FormErrorMessage,
} from "@chakra-ui/react";
import { useNavigate } from "react-router";
import Logo from "../../../assets/img/Logo.svg";
import Vezarat from "../../../assets/img/amoozesh-logo.png";
import Header from "common/components/Header/Header";
import { Field, Form, Formik, FormikProps } from "formik";

import { useGetOTPQuery } from "api/auth.api";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { MobilePhoneRegex } from "utils/MobilePhoneRegex";
export interface ISignInValue {
  phoneNumber: string;
}
function SignIn({
  setStep,
  setIsNewUser,
  setPhoneNumber,
}: {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setIsNewUser: React.Dispatch<React.SetStateAction<boolean>>;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
}) {
  // Chakra color mode
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("rgb(97, 97, 97)", "white");
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);

  const formikRef = useRef<FormikProps<ISignInValue>>(null);

  const phoneNum = formikRef.current?.values.phoneNumber;
  const queryArg = clicked && phoneNum ? phoneNum : skipToken;

  const { data, isFetching, isSuccess, error } = useGetOTPQuery(queryArg);

  useEffect(() => {
    if (data?.isNewUser) {
      setIsNewUser(true);
    }
  }, [data]);

  useEffect(() => {
    if (isSuccess) {
      setStep(1);
      navigate("/auth/verifyotp")
    }
  }, [isFetching]);

  function onsubmit(values: ISignInValue) {
    console.log("formikRef", phoneNum);
    setClicked(true);
    setPhoneNumber(values.phoneNumber);
    // ‌;
  }
  function validate(phoneNumber: string) {
    let error;
    if (!phoneNumber) {
      error = "لطفا شماره موبایلتان را وارد کنید.";
    } else if (!MobilePhoneRegex.test(phoneNumber)) {
      error = "شماره موبایل معتبر نیست";
    }
    return error;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      style={{ userSelect: "none" }}
      w={{ md: "50%", lg: "40%", sm: "80%" }}
      mb={{ "2xl": "40px" }}
      mt={{
        base: "150px",
        "2xl": "150px",
        xl: "150px",
        md: "40px",
        sm: "40px",
      }}
      className="authCard"
    >
      <Flex direction="column" w="100%" background="transparent" p={{base : "15px" , sm : "10px" , md: "10px" , lg: "20px" , xl : "20px"}}>
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="header"
          mt="30px"
          mb="80px"
        >
          <img src={Logo} className="header-logo" />
          <img src={Vezarat} className="logo-text" />
          {/* <Header headerClass="header-logo" textClass="logo-text"/> */}
        </Flex>
        <Flex justifyContent="center">
          <Heading
            color={textColor}
            fontSize={{ base: "30px", xl: "30px", "2xl": "30px", sm: "20px" }}
            mb="50px"
          >
            سامانه رزرو قرار ملاقات
          </Heading>
        </Flex>

        <Heading
          color={textColor}
          fontSize={{ base: "25px", xl: "25px", "2xl": "25px", sm: "20px" }}
          mb="20px"
        >
          ورود به سامانه
        </Heading>
        <Formik
          innerRef={formikRef}
          initialValues={{ phoneNumber: "" }}
          onSubmit={onsubmit}
        >
          {(formikProps) => (
            <Form>
              <Field name="phoneNumber" validate={validate}>
                {({ field, form }: any) => (
                  <FormControl
                    isInvalid={
                      form.errors.phoneNumber && form.touched.phoneNumber
                    }
                  >
                    <Input
                      {...field}
                      borderRadius="15px"
                      fontSize="sm"
                      placeholder="شماره موبایل خود را وارد کنید."
                      size="lg"
                      type="tel"
                      // value={value}
                      // onChange={onChange}
                      borderColor="gray"
                    />

                    <FormErrorMessage mt={0} pr={2}>
                      {form.errors.phoneNumber}
                    </FormErrorMessage>
                    <Button
                      // onClick={onClick}
                      fontSize="15px"
                      type="submit"
                      bg="teal.300"
                      w="100%"
                      h="45"
                      mb="20px"
                      color="white"
                      mt="20px"
                      _hover={{
                        bg: "teal.200",
                      }}
                      _active={{
                        bg: "teal.400",
                      }}
                      isDisabled={
                        !formikProps.isValid || !formikProps.values.phoneNumber
                      }
                    >
                      ارسال کد
                    </Button>
                  </FormControl>
                )}
              </Field>
            </Form>
          )}
        </Formik>
      </Flex>
    </Flex>
  );
}

export default SignIn;
